var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-preview-3d-view" },
    [
      _c("EditorDrawView", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        attrs: {
          "bleed-margin": _vm.computedBleedMargin,
          "draw-mask": true,
          "draw-objects": _vm.pageObjects,
          "draw-page": true,
          height: _vm.pageModel.height,
          "offering-frame-model": _vm.offeringFrameModel,
          "offering-model": _vm.offeringModel,
          "page-model": _vm.pageModel,
          scaling: _vm.computedFullScaling,
          "show-editor-offering-frame": false,
          width: _vm.pageModel.width,
        },
        on: { drawn: _vm.onCanvasDrawn },
      }),
      _c("div", { staticClass: "editor-preview-3d-view-container" }, [
        _c("canvas", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isReady,
              expression: "isReady",
            },
          ],
          ref: "canvas",
        }),
        _c(
          "svg",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isReady,
                expression: "!isReady",
              },
            ],
            staticClass: "editor-preview-3d-view-load-icon-svg",
            attrs: { viewBox: "0 0 32 32", width: "64", height: "64" },
          },
          [
            _c("circle", {
              staticClass: "editor-preview-3d-view-load-icon-circle",
              attrs: { cx: "16", cy: "16", r: "14", fill: "none" },
            }),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }